import { render, staticRenderFns } from "./ContentCreate.vue?vue&type=template&id=b37e1558&"
import script from "./ContentCreate.vue?vue&type=script&lang=js&"
export * from "./ContentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports